module.exports = __webpack_public_path__ + "media/Shot02_Arm_Pulse.mp4";